import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["results", "item"];

  get parent() {
    return this.itemTarget.value;
  }

  get selected() {
    return this.data.get("selected")
  }

  get url() {
    return [this.data.get("url"), this.parent].join("/")
  }

  connect() {
    console.log("SelectController.connect()");
    this.handleChange();
  }

  handleChange() {
    if (!this.parent) { return; }

    fetch(this.url)
      .then(response => response.json())
      .then(data => { this.populateSelect(data) })
  }

  populateSelect(data) {
    this.resultsTarget.innerHTML = "";

    data.forEach(item => {
      let opt = document.createElement("option");
      opt.value = item.id;
      if (String(this.selected) === String(item.id)) {
        opt.selected = true;
      }

      opt.innerHTML = item.name;
      this.resultsTarget.append(opt);
    })

    this.resultsTarget.disabled = false;
  }
}